$(function(){
  if( $("body").is(".theme-special") ){

    // js-tab-list
    //------------------------------------------------------------
    $(".js-tab-list a").on('click', function(){
      var href = $(this).attr("data-href");
      $(".js-tab-list a").removeClass("is-active");
      $("[data-tabcont]").removeClass("is-active");
      $(".js-tab-list [data-href='"+ href +"']").addClass("is-active");
      $("[data-tabcont='"+ href +"']").addClass("is-active");

      var pos;
      if( $("html").attr("data-mode") === "pc" ){
        pos = $(".js-tab-list").offset().top;
        pos = pos - 30;
        $('html,body').not(":animated").animate({ scrollTop: pos }, 0);
      } if( $("html").attr("data-mode") === "sp" ){
        pos = $(".js-tab-list").offset().top;
        pos = pos - 60;
        $('html,body').not(":animated").animate({ scrollTop: pos }, 0);
      }
    });

    // lazyload
    //------------------------------------------------------------
    $(".special__sec figure img").lazyload({
      effect : "fadeIn"
    });
  }
});


// WEBPACK FOOTER //
// ./_src/js/cont/special.js